// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/image.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/image.proto.
 */
export const file_api_proto_v1_image: GenFile = /*@__PURE__*/
  fileDesc("ChhhcGlfcHJvdG8vdjEvaW1hZ2UucHJvdG8SDGFwaV9wcm90by52MSIoCg1JbWFnZVJlc3BvbnNlEgoKAmlkGAEgASgDEgsKA3VybBgCIAEoCUIzWjFnaXRodWIuY29tL2gtc2NhcGUvaWVzYXB1cmkvZ28vYXBpX3Byb3RvL3YxO2FwaXYxYgZwcm90bzM");

/**
 * @generated from message api_proto.v1.ImageResponse
 */
export type ImageResponse = Message<"api_proto.v1.ImageResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message api_proto.v1.ImageResponse.
 * Use `create(ImageResponseSchema)` to create a new message.
 */
export const ImageResponseSchema: GenMessage<ImageResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_image, 0);

